import { render, staticRenderFns } from "./GiveAwayHelpForm.vue?vue&type=template&id=e0f968da&scoped=true&"
import script from "./GiveAwayHelpForm.vue?vue&type=script&lang=js&"
export * from "./GiveAwayHelpForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f968da",
  null
  
)

export default component.exports